jQuery(function($) {
    // On va chercher le nombre de code demandé et on les affiches.
    $('.get_codes').on('submit', function(e) {
        e.preventDefault();
        var form = $(this);

        if (form.find('[type="submit"]').prop('disabled')) {
            return false;
        }

        var result_data = {
            action: 'neuro_get_codes_for_use',
            _ajax_nonce: neurotestData._nonce,
            total: form.find('input[name="number_of_code"]').val(),
            fast_ajax: true,
            load_plugins: [
                "neurotypingtest/neurotypingtest.php",
                "advanced-custom-fields-pro/acf.php",
                "sitepress-multilingual-cms/sitepress.php",
                "wpml-string-translation/plugin.php"
            ]
        }

        form.find('[type="submit"]').prop('disabled', true);

        $.post(neurotestData.ajax_url, result_data, function(res) {
            let total = parseInt($('.available_total').text());
            let unlocked_total = parseInt($('.unlocked_total').text());

            if(res.success) {
                total = Math.max(0, total - res.codes.length);
                unlocked_total = Math.max(0, unlocked_total + res.codes.length);

                let template = $('.neuro_codes_available .template').clone();

				$('.hide:not(.neuro-spinner)').removeClass('hide');
				$('.neuro_code_list_start_unlocking').remove();

				$('.available_total').text(total);
                $('.unlocked_total').text(unlocked_total);

                form.find('input[name="number_of_code"]').attr('max', total);

                template.removeClass('template').addClass('new_unlocked_code').css('opacity', 0);
                template.find('.date').text(neurotestData.textNow);

                for (let i = 0; i < res.codes.length; i++) {
                    let clone_template = template.clone();

                    clone_template.find('.code').text(res.codes[i]);
                    let clone_link = clone_template.find('.get_url a');
                    let clone_url = clone_link.attr('href') + '?code=' + res.codes[i];
                    clone_link.attr('href', clone_url).text(clone_url);
                    clone_template.find('.js-send-code').attr('data-code', res.codes[i]);

                    $('.neuro_codes_available tbody').prepend(clone_template);

                    clone_template.animate({
                        opacity: 1
                    }, 300);
                }
            }

            if(total > 0) {
                form.find('[type="submit"]').prop('disabled', false);
            }

        }, 'json');
    });

    // On vérouille le code demandé et on le retire de la liste.
    $('.neuro_codes_available').on('click', '.remove_pending_code', function(e) {
        var tr_parent = $(this).parents('tr');

        if (tr_parent.hasClass('locking')) {
            return false;
        }

        var result_data = {
            action: 'neuro_lock_code',
            _ajax_nonce: neurotestData._nonce,
            code: tr_parent.find('.code').text(),
            fast_ajax: true,
            load_plugins: [
                "neurotypingtest/neurotypingtest.php",
                "advanced-custom-fields-pro/acf.php",
                "sitepress-multilingual-cms/sitepress.php",
                "wpml-string-translation/plugin.php"
            ]
        }

        tr_parent.addClass('locking');

        $.post(neurotestData.ajax_url, result_data, function(res) {
            if(res.success) {
                let total = parseInt($('.available_total').text()) + 1;
                let unlocked_total = parseInt($('.unlocked_total').text()) - 1;

                $('.available_total').text(total);
                $('.unlocked_total').text(unlocked_total);

                $('.get_codes input[name="number_of_code"]').attr('max', total);
                $('.get_codes [type="submit"]').prop('disabled', false);

                tr_parent.fadeOut(300, function() {
                    tr_parent.remove();
                });

            } else {
                tr_parent.removeClass('locking');
            }

        }, 'json');
    });

    // On utilise un code pour faire un test.
    $('#neurotyping_test_use_code').on('submit', function(e) {
        var button = $(this).find('.button[type="submit"]');
        var form = $(this);
        form.find('.error_log').hide().text('');

        if(button.hasClass('disabled')) {
            return false;
        }

        e.preventDefault();

        var code_data = {
            action: 'neuro_use_code',
            _ajax_nonce: neurotestData._nonce,
            code: $(this).find('input[name="neurotyping_code"]').val(),
            fast_ajax: true,
            load_plugins: [
                "neurotypingtest/neurotypingtest.php",
                "advanced-custom-fields-pro/acf.php",
                "sitepress-multilingual-cms/sitepress.php",
                "wpml-string-translation/plugin.php"
            ]
        }

        button.addClass('disabled');
        button.next('.spinner').addClass('is-active');

        $.post(neurotestData.ajax_url, code_data, function(res) {
            if(res.result == true) {
                window.location = neurotestData.neurotest_url;
            } else {
                button.removeClass('disabled');
                button.next('.spinner').removeClass('is-active');
                form.find('.error_log').text(neurotestData.code_error).show();
            }
        }, 'json');
    });

    $('#neurotyping-test [type="submit"]').on('click', function(e) {
        $('#neurotyping-test [type="submit"]').removeClass('clicked');
        $(this).addClass('clicked');
    });

    // Gestion des prev / next du form.
    $('#neurotyping-test').on('submit', function(e) {
        var button = $(this).find('[type="submit"].clicked');
        var form = $(this);
        var valid = true;

        if (form.hasClass('disabled')) {
            return false;
        }

        form.find('fieldset').removeClass('invalid');

        // A default value is setted
        // if (button.val() == 'next') {
        //     form.find('.questions-wrap input').each(function() {
        //         if (!form.find("input[name='" + $(this).attr('n``ame') + "']:checked").length) {
        //             $(this).parents('fieldset').addClass('invalid');
        //             valid = false;
        //         }
        //     });
        // }

        if (!valid) {
            let offsetInvalid = form.find('.questions-wrap fieldset.invalid').offset().top;
            offsetInvalid = offsetInvalid - $('#masthead').height();

            // $('html, body').animate({
            //     scrollTop: offsetInvalid
            // }, 500);

            return false;
        }

        e.preventDefault();

        var form_data = {
            action: 'neuro_test_form_action',
            values: $(this).serializeArray(),
            _ajax_nonce: neurotestData._nonce,
            button_action: button.val(),
            page_progress: $('[name=page_progress]').val(),
            fast_ajax: true,
            load_plugins: [
                "neurotypingtest/neurotypingtest.php",
                "woocommerce/woocommerce.php",
                "advanced-custom-fields-pro/acf.php",
                "sitepress-multilingual-cms/sitepress.php",
                "wpml-string-translation/plugin.php",
                "woocommerce-email-control/ec-email-control.php"
            ]
        }

        form.addClass('disabled');

        $.post(neurotestData.ajax_url, form_data, function(res) {
            if (res.success == true) {
                if (res.done && res.code) {
                    window.location = neurotestData.neurotest_result_url + '/' + res.code + '/';
				} else if (res.done) {
					window.location = neurotestData.neurotyping_url;
				} else {
                    let progression = res.page_progress/form.attr('data-total-pages');

                    if (progression !== undefined) {
                        let transformValue = `scaleX(${progression})`;

                        $('.js-progress-bar > div')[0].style.webkitTransform = transformValue;
                        $('.js-progress-bar > div')[0].style.msTransform = transformValue;
                        $('.js-progress-bar > div')[0].style.transform = transformValue;
                    }

                    if(res.last == true) {
                        $('.js-buttons-wrap button.submit').removeClass('is-hidden');
                        $('.js-buttons-wrap button.next').addClass('is-hidden');
                    } else {
                        $('.js-buttons-wrap button.submit').addClass('is-hidden');
                        $('.js-buttons-wrap button.next').removeClass('is-hidden');
                    }

                    $('[name=page_progress]').val(res.page_progress);

                    if (res.content != '') {
                        let new_questions = $(res.content);

                        new_questions.addClass('in-'+button.val());

                        form.find('.questions-wrap').addClass('out-'+button.val()).on('transitionend webkitTransitionEnd oTransitionEnd', function(){
                            $(this).remove();
                            form.height('');
                        });

                        form.find('.js-buttons-wrap').before(new_questions);

                        let anim_form_height = form.find('.questions-wrap').height() > new_questions.height() ? form.find('.questions-wrap').height() : new_questions.height();
                        let offset_height = new_questions.height() - anim_form_height;

                        form.height(form.height - offset_height);

                        setTimeout(() => {
                            new_questions.removeClass('in-prev in-next');
                        }, 100);
                    }

                    if(res.page_progress <= 0) {
                        form.find('[type="submit"][value="prev"]').addClass('is-hidden');
                    } else {
                        form.find('[type="submit"][value="prev"]').removeClass('is-hidden');
                    }

                    let event = new CustomEvent(
                        'reinitQuestions',
                        {
                            'detail': {
                                scope: form.get(0)
                            }
                        }
                    );
                    document.dispatchEvent(event);

                    form.removeClass('disabled');
                }

            } else {
                form.removeClass('disabled');

                // if(typeof form.find('.questions-wrap fieldset.invalid').offset() !== 'undefined') {
                //     let offsetInvalid = form.find('.questions-wrap fieldset.invalid').offset().top;
                //     offsetInvalid = offsetInvalid - $('#masthead').height();

                    // $('html, body').animate({
                    //     scrollTop: offsetInvalid
                    // }, 500);
                // }
            }

        }, 'json');
    });


	/**
	 * Remove Invalid class from invalid fieldset on editing
	 */
	$('#neurotyping-test').on('click','fieldset.invalid label',function() {
		$(this).closest('.invalid').removeClass('invalid');
	});


    var delay;
    var last_value = '';
    $('input[name="search_used_code"]').on('change keyup', function() {
        if ($(this).val() == last_value) {
            return false;
        }

        last_value = $(this).val();

        clearTimeout(delay);

        delay = setTimeout(() => {
            var search_data = {
                action: 'neuro_search_used_code',
                _ajax_nonce: neurotestData._nonce,
                search: $(this).val(),
                fast_ajax: true,
                load_plugins: [
                    "woocommerce/woocommerce.php",
                    "advanced-custom-fields-pro/acf.php",
                    "neurotypingtest/neurotypingtest.php",
                    "sitepress-multilingual-cms/sitepress.php",
                    "wpml-string-translation/plugin.php"
                ]
            }

            $.post(neurotestData.ajax_url, search_data, function(res) {
                if (res.success == true) {
                    $('.neuro_codes_used li.user_code:not(.li_header)').remove();
                    $('.neuro_codes_used').append(res.results);
                }
            }, 'json');
        }, 1000);
    });

    // Select tous le code au click.
    $('.neuro_codes_list').on('click', '.user_code .code', function() {
        var selection = window.getSelection();
        var range = selection.getRangeAt(0);

        range.selectNode(this);
    });

	$('#send-result-by-email').on('submit',function(e) {
		e.preventDefault();
		var data = {
			action: 'neuro_send_result_by_email',
			email:$('#send-result-by-email-address').val(),
			code: $('#send-result-by-email-id').val(),
            version: $('#send-result-by-email-version').val(),
			_ajax_nonce: neurotestData._nonce,
            fast_ajax: true,
            load_plugins: [
                "neurotypingtest/neurotypingtest.php",
                "woocommerce/woocommerce.php",
                "advanced-custom-fields-pro/acf.php",
                "sitepress-multilingual-cms/sitepress.php",
                "wpml-string-translation/plugin.php",
                "woocommerce-email-control/ec-email-control.php"
            ]
		};
		$('#send-result-by-email-response').text('')
		$(this).removeClass('error')
				.find('.spinner').addClass('is-active');

		$.post(neurotestData.ajax_url, data, function(res) {
			$('#send-result-by-email').find('.spinner').removeClass('is-active');
			if (res.success) {
				$('#send-result-by-email-address').val('');
			} else {
				$('#send-result-by-email').addClass('error');
			}
			if (res.message) {
				$('#send-result-by-email-response').fadeIn().text(res.message);
			}
		}, 'json');

	});

    
    $(document).on('click', '.js-send-code', function(e) {
        var modal = document.getElementById("neuro-form-modal");
        var closeBtn = modal.getElementsByClassName("close")[0];
        var modalCode = modal.getElementsByClassName("js-form-code")[0];
        var modalCodeLabel = modal.getElementsByClassName("js-label-code")[0];

        // Show popup & set code
        modal.style.display = "block";
        modalCodeLabel.innerHTML = $(this).data('code');
        modalCode.value = $(this).data('code');

        // Modal closing
        closeBtn.onclick = function() {
            modal.style.display = "none";
        }
        window.onclick = function(event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        }
    });

    var sendCodeByEmailRequest = false;
    $('#send-code-by-email').on('submit',function(e) {
		e.preventDefault();
        if(sendCodeByEmailRequest) {
            return;
        }
        sendCodeByEmailRequest = true;
        var labelMessage = $(this).find('.js-label-message'); 
        labelMessage.text('');
        var spinner = $(this).find('.neuro-spinner'); 
        spinner.removeClass('hide');

        $.ajax({
            type : 'POST',
            url : neurotestData.ajax_url,
            data :  $(this).serialize() + 
                "&action=neuro_send_code_by_email" + 
                "&_ajax_nonce=" + neurotestData._nonce,
            success: function (data) {
                sendCodeByEmailRequest = false;
                spinner.addClass('hide');
                if(data.message) {
                    labelMessage.text(data.message);
                }
            }
        });

	});
});
